module.exports = __webpack_public_path__ + "static/media/change_credentials.692c4791.svg";